import React from 'react';
import { ClipboardList, AlertTriangle, CheckCircle2, Clock, Eye } from 'lucide-react';

// QC-CORRECTION-UI-001 — premium compact "QC Correction Required" banner.
// Pure presentation over the /qc-feedback payload; "View Details" reopens the modal.
export default function CorrectionReminderBar({ data, isReturn, onViewDetails }) {
  const isAcked = !!data?.qc_feedback_acknowledged_at;
  const iteration = data?.qc_iteration || 1;
  return (
    <div className={`qc-corr-banner ${isReturn ? '' : 'qc-corr-banner--rejected'}`}
      data-testid="processor-feedback-banner" data-acknowledged={isAcked ? 'true' : 'false'}>
      <div className="qc-corr-banner-icon" aria-hidden="true">
        <ClipboardList className="w-5 h-5" strokeWidth={2} />
        <span className="qc-corr-banner-icon-badge"><AlertTriangle className="w-2.5 h-2.5" strokeWidth={3} /></span>
      </div>
      <div className="qc-corr-banner-divider" aria-hidden="true" />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <h3 className="text-base font-bold text-slate-900 leading-tight" data-testid="correction-banner-title">
            {isReturn ? 'QC Correction Required' : 'QC Rejected — Revisions Required'}
          </h3>
          <span className="qc-corr-chip qc-corr-chip--amber" data-testid="correction-banner-iteration">Iteration {iteration}</span>
          {isAcked ? (
            <span className="qc-corr-chip qc-corr-chip--green" data-testid="correction-reminder-acked">
              <CheckCircle2 className="w-3.5 h-3.5" /> Acknowledged
            </span>
          ) : (
            <span className="qc-corr-chip qc-corr-chip--pending" data-testid="correction-reminder-unacked">
              <Clock className="w-3.5 h-3.5" /> Awaiting Acknowledgement
            </span>
          )}
        </div>
        <p className="text-sm text-slate-700 mt-0.5 truncate" data-testid="correction-banner-guidance">
          {isAcked
            ? 'Review the QC feedback and make the required corrections in Fulfillment.'
            : 'Acknowledge the QC feedback to unlock Fulfillment and begin corrections.'}
        </p>
      </div>
      <button type="button" onClick={onViewDetails} className="qc-corr-banner-btn" data-testid="correction-reminder-view-details">
        <Eye className="w-4 h-4" /> {isAcked ? 'View Details' : 'Review'}
      </button>
    </div>
  );
}
